import axios from 'axios';
import Api from './ApiUrl'


const API_URL = `${Api}/api/v1/items`;

export const getItems = async (page,limit) => {
  const config = {
    // headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    // },
    role: 'admin'
};
  // const response = await axios.get(API_URL);
  const response = await axios.get(`${API_URL}?page=${page}&limit=${limit}`,config);

  return response.data;
};
export const getItemById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

export const createItem = async (item) => {
  console.log(item)
  const response = await axios.post(API_URL, item);
  console.log(response)
  return response.data;
};

export const updateItem = async (id, item) => {
  const response = await axios.put(`${API_URL}/${id}`, item);
  return response.data;
};

export const deleteItem = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};
